import query from './APIServices'

interface Countries {
  id: number
  name: string
  code: string
  flag: string
  priority: number
  prefix: string
}

export const getCountries = async () => {
  const response = await query.get('/invoice/public/countries')
  return response?.data.items as Countries[]
}
